import type { ProgramUserRsvp } from 'models';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const updateEventUserStatus = async (eventId: string, statusToApply: ProgramUserRsvp) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.events.updateUserStatus(eventId), {
    rsvp: statusToApply,
  });
